<mat-slide-toggle *ngFor="let filter of toggleFilters; index as i"
        [(ngModel)]="toggleFilters[i].toggled"
        [color]="'accent'"
        class="toggle-filter"
        (change)="toggleFilterChange.emit(toggleFilters[i])">
    {{ toggleFilterPrompts[i] }}
</mat-slide-toggle>

